
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Les produits distribués en Suisse font l'objet d'un
`}<a parentName="p" {...{
        "href": "291128389286"
      }}>{`suivi rapproché`}</a>{` et d’éventuels effets secondaires doivent être
signalés.`}</p>
    <p>{`De manière générale,
`}<a parentName="p" {...{
        "href": "https://ofsp-coronavirus.ch/vaccination/effets-secondaires-et-questions/"
      }}>{`on a surtout annoncé`}</a>{`
pour ces vaccins des réactions au site d’injection (notamment des rougeurs), des
douleurs musculaires ou articulaires, des frissons, des maux de tête, de la
fièvre…`}</p>
    <p>{`Ces effets secondaires, qui sont plus fréquents après la deuxième dose, sont
classiques après un vaccin, quel qu’il soit. Alessandro Diana, expert chez
Infovac, les qualifie de «bas grade», soit pas dangereux. Mais
`}<a parentName="p" {...{
        "href": "955444364599"
      }}>{`il a été surpris par leur fréquence`}</a>{`.`}</p>
    <p>{`Selon Blaise Genton, responsable médical de la campagne vaudoise de vaccination,
la fièvre touche environ une personne sur dix après la première dose et une à
deux sur dix après la deuxième. Environ la moitié des individus sont fatigués ou
patraques et la majorité ont une douleur au point d’injection. "Il semble que
ces situations sont un peu plus fréquentes avec le vaccin de Moderna, mais la
différence est vraiment faible."`}</p>
    <p>{`Une consolation pour ceux qui sont au lit: "Si ces produits sont relativement
réactogènes, ils figurent parmi les plus efficaces", assure Blaise Genton. Les
deux choses vont de pair. Alessandro Diana compare la vaccination à un
entraînement, dans lequel le système immunitaire apprend à résister à un virus.
"Dans le cas du Covid, cela ressemble plus à une instruction militaire qu’à un
tour de présentation du fitness." Forcément, l’exercice est bon, mais il peut
malmener. Il faut préciser que ce principe vaut à un niveau "global" et non
individuel: si vous n'avez pas réagi, cela ne signifie pas que le vaccin n'a pas
fonctionné chez vous.`}</p>
    <p>{`Parmi les réactions, on peut aussi mentionner une détresse respiratoire, la
réactivation de zonas, des nausées ou des vomissements. Swissmedic indique que,
dans la plupart des cas, la santé des sujets n'a pas été mise en danger. Un
effet secondaire grave est le
`}<a parentName="p" {...{
        "href": "https://www.infovac.ch/docs/public/coronavirus/ssai-recommandations-pour-vaccins-contre-covid-19-en-cas-d-allergies-v8-2-f.pdf"
      }}>{`choc anaphylactique`}</a>{`
qui se produit chez certaines personnes dans les minutes suivant l'injection.
Ces accidents, qui ne concernent pas plus d'un individu sur 300'000, peuvent
être stoppés avec une injection d'adrénaline.`}</p>
    <p>{`Y a-t-il des risques à plus long terme? "Il pourrait s'agir de réactions
auto-immunes, mais elles se produisent en général dans les six à huit semaines
après la vaccination, répond Alessandro Diana. Avec toutes les personnes qui ont
été prises en charge dans le monde, nous sommes vraiment confiants."`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;